// Dependencies
import { h } from 'preact';
import lottie from 'lottie-web';
import { useEffect, useRef } from 'preact/hooks';

// Component
const LottieAnimation = ({ animationData, loop = true }) => {
  const animationContainer = useRef(null);

  useEffect(() => {
    const animation = lottie.loadAnimation({
      container: animationContainer.current,
      renderer: 'svg',
      loop: loop,
      autoplay: true,
      animationData: animationData,
    });

    return () => {
      animation.destroy();
    };
  }, [animationData]);

  return (
    <div
      ref={animationContainer}
      style={{ width: '100%', height: '100%' }}
    />
  );
};

export default LottieAnimation;


// WEBPACK FOOTER //
// ./components/elements/LottieAnimation/index.js